import { ButtonProps } from '@mui/material';
import { useFormikContext } from 'formik';
import { Button as MUIButton } from 'components';

export const Button = ({ children, ...props }: ButtonProps) => {
  const { submitForm } = useFormikContext();

  const handleSubmit = () => {
    submitForm();
  };

  return (
    <MUIButton
      variant="contained"
      color="primary"
      onClick={handleSubmit}
      sx={{ color: '#FFFFFF' }}
      {...props}
    >
      {children}
    </MUIButton>
  );
};
